import { render, staticRenderFns } from "./NoDataChart.vue?vue&type=template&id=07fa6c0f&scoped=true&"
import script from "./NoDataChart.vue?vue&type=script&lang=js&"
export * from "./NoDataChart.vue?vue&type=script&lang=js&"
import style0 from "./NoDataChart.vue?vue&type=style&index=0&id=07fa6c0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa6c0f",
  null
  
)

export default component.exports